interface MessageProps {
  text: string;
  sender: 'user' | 'bot';
}

export function Message({ text, sender }: MessageProps) {
  return <div className={`message ${sender}`}>{text}</div>;
}
